// Plan-card backgrounds, drawn in CSS instead of the old bg-{blue,gold,purple}.webp files.
//
// Those files were 800x1280 renders of exactly this: a near-black base (#151419 at the top of
// every one of them) with a single soft radial glow low in the frame. The stops here were
// sampled from the files — glow centre, mid-fall-off and base — so the cards look the same,
// but paint on the first frame instead of after a network round trip, and re-rasterise
// cleanly on resize rather than resampling a bitmap. A tint stop between glow and base is what
// keeps a dark, low-contrast gradient from banding; drop it and OLED screens show rings.
//
// Values are complete `background-image` strings so a consumer can keep its existing
// opacity/hover classes untouched: it swaps `url(...)` for one of these and deletes the
// background-size/position lines, which have no meaning for a gradient.
export const CARD_BACKGROUNDS = {
  // Plus / Premium / free card / gem packs / declined banner
  blue: 'radial-gradient(ellipse 70% 55% at 61% 89%, #20203a 0%, #1a1822 45%, #151419 100%)',
  // Pro ("Studio" internally)
  gold: 'radial-gradient(ellipse 70% 55% at 53% 88%, #302a23 0%, #1f1c1d 45%, #151419 100%)',
  // Max (only in the maxAbValue === 'B' lineup)
  purple:
    'radial-gradient(ellipse 75% 60% at 84% 79%, #393065 0%, #292347 40%, #16151a 100%)',
}

// Background for a plan card by the plan's INTERNAL name (see plan-facts.js: Pro is "Studio").
export const cardBackgroundFor = (planName) =>
  planName === 'Studio'
    ? CARD_BACKGROUNDS.gold
    : planName === 'Max'
      ? CARD_BACKGROUNDS.purple
      : CARD_BACKGROUNDS.blue
